<p-dialog
  [header]="'bills.send-email.popup' | translate"
  [(visible)]="popup"
  [modal]="true"
  [closable]="true"
  (onHide)="clearPopup()"
  appendTo="body"
  [style]="{ width: '30vw', 'max-height': '40vh', 'overflow-y': 'auto' }"
>
  <div class="row">
    <div class="col-md-12">
      <div>
        <div class="form-group">
          <h4>{{ "bills.send-email.bill-email" | translate }}:</h4>
          <div class="email-chips" *ngIf="billEmail">
            <div
              class="email-chip mb-2"
              [class.selected]="isEmailSelected(billEmail)"
              (click)="toggleEmail(billEmail)"
              role="button"  tabindex="-1"
            >
              {{ billEmail }}
            </div>
          </div>
          <h4>{{ "bills.send-email.sended-emails" | translate }}:</h4>
          <p-chips
            [allowDuplicate]="false"
            [(ngModel)]="selectedEmails"
            (onAdd)="handleChipAdd($event)"
          />
        </div>
      </div>
      <div></div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button class="send-button" (click)="sendEmail()">
      {{ "common.send" | translate }}
    </button>
  </ng-template>
</p-dialog>
